const STORAGE_KEY = "intentsify.oauth.return-path";
const OAUTH_INTERACTION_PATH = /^\/oauth\/authorize\/[A-Za-z0-9_-]{8,512}$/;

const saveOAuthReturnPath = (pathname: string): boolean => {
  if (!OAUTH_INTERACTION_PATH.test(pathname)) {
    return false;
  }

  sessionStorage.setItem(STORAGE_KEY, pathname);
  return true;
};

const consumeOAuthReturnPath = (): string | undefined => {
  const pathname = sessionStorage.getItem(STORAGE_KEY) ?? undefined;
  sessionStorage.removeItem(STORAGE_KEY);

  return pathname && OAUTH_INTERACTION_PATH.test(pathname)
    ? pathname
    : undefined;
};

export { consumeOAuthReturnPath, saveOAuthReturnPath };
